import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import api from "../lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        // No localStorage - the backend set the HttpOnly session_token cookie.
        window.history.replaceState({}, "", "/dashboard");
        toast.success(`Bienvenue ${data.user.name?.split(" ")[0] || ""}!`);
        navigate("/dashboard", { state: { user: data.user } });
      } catch (e) {
        console.error("auth callback failed:", e);
        toast.error("Échec d'authentification");
        navigate("/login");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto rounded-full border-2 border-gold border-t-transparent animate-spin" />
        <p className="mt-4 label-mono">Connexion sécurisée...</p>
      </div>
    </div>
  );
}
